export default __webpack_public_path__ + "static/media/005-violin.54980329.svg";